import { createStore, applyMiddleware, combineReducers } from 'redux'
import { thunk } from 'redux-thunk'
import generalDataReducer from './reducers/generalDataReducer'
import clientDataReducer from './reducers/clientDataReducer'
import languageReducer from './reducers/languageReducer'
import sidenavReducer, { presectionReducer } from './reducers/sidenavReducer'
import titleReducer from './reducers/titleReducer'
import sectionDataReducer from './reducers/sectionDataReducer'

const rootReducer = combineReducers({
  generalData: generalDataReducer,
  clientData: clientDataReducer,
  clientSections: sectionDataReducer,
  isClientPreSection: presectionReducer,
  language: languageReducer,
  sidenav: sidenavReducer,
  title: titleReducer,
})

const store = createStore(rootReducer, applyMiddleware(thunk))

export default store
